/**
 * Utility functions for location validation and checks
 */

/**
 * Check if a location is FAL PoU
 */
export const isFALPoULocation = (primaryLocation: string): boolean => {
  const normalizedLocation = primaryLocation.toLowerCase().trim();
  return normalizedLocation === "fal pou" || normalizedLocation === "fal point of use";
};

/**
 * Check if a location is Airlog Empty Holding
 */
export const isAirlogEmptyHoldingLocation = (primaryLocation: string): boolean => {
  const normalizedLocation = primaryLocation.toLowerCase().trim();
  return normalizedLocation === "airlog empty holding" || normalizedLocation === "airlog empty holding area";
};

/**
 * Check if a trolley status indicates it has totes loaded (LOADING or UNLOADING)
 */
export const hasTotesLoaded = (trolleyStatus: string): boolean => {
  const normalizedStatus = trolleyStatus.toLowerCase().trim();
  return normalizedStatus === "loading" || normalizedStatus === "unloading";
};

/**
 * Check if a trolley is empty (Empty - Not Available)
 */
export const isTrolleyEmpty = (trolleyStatus: string): boolean => {
  const normalizedStatus = trolleyStatus.toLowerCase().trim();
  return normalizedStatus === "empty - not available" || normalizedStatus === "empty";
};

